package api


@Suppress("ClassName")
sealed class HardwareType(val type: Int, val label: String) {
    data object UNDEFINED : HardwareType(2, "UNDEFINED")
    data object COMPUTER : HardwareType(4, "COMPUTER")
    data object SCREEN : HardwareType(8, "SCREEN")

    infix fun match(type: Int): Boolean = this.type == type

    companion object {
        val all by lazy {
            listOf(UNDEFINED, COMPUTER, SCREEN)
        }

        operator fun get(type: Int): HardwareType {
            return all.firstOrNull {
                it.type == type
            } ?: UNDEFINED
        }
    }
}

